import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortSlots',
    standalone: false
})
export class SortSlotsPipe implements PipeTransform {

  transform(slots: any[], sortBy: string = 'slotTime'): any[] {
    if (!slots || !Array.isArray(slots)) {
      return [];
    }

    // Sort slots based on the 'slotTime' or other property if specified
    return slots.sort((a, b) => {
      const timeA = new Date(a[sortBy]).getTime();
      const timeB = new Date(b[sortBy]).getTime();
      return timeA - timeB;
    });
  }
}